import { isDeskNotesPath } from '../utils/desk-notes-location';
import { getAdminBreadcrumbItems } from './admin/admin-nav';

export function getBreadcrumbItems(
  pathname: string,
  t: (key: string) => string,
  extras?: {
    documentTitle?: string;
    projectTitle?: string;
  },
): string[] {
  const documentTitle = extras?.documentTitle;
  const projectTitle = extras?.projectTitle;

  if (pathname.includes('/documents/') && documentTitle) {
    const items: string[] = [];
    if (projectTitle) {
      items.push(projectTitle);
    }
    items.push(documentTitle);
    return items;
  }

  if (pathname === '/desk') {
    return [];
  }
  if (pathname === '/projects' || pathname === '/desk/import') {
    return [t('all_documents')];
  }
  if (pathname === '/desk/trash') {
    return [t('trash')];
  }
  if (pathname === '/desk/settings') {
    return [t('user_settings') || 'User settings'];
  }
  if (pathname === '/desk/notifications') {
    return [t('notifications')];
  }
  if (pathname === '/desk/shared-with-me') {
    return [t('shared_with_me') || 'Shared with me'];
  }
  if (pathname === '/desk/usage-and-billing') {
    return [t('usage_and_billing')];
  }
  if (isDeskNotesPath(pathname)) {
    return [t('Notes') || 'Notes'];
  }
  if (pathname.startsWith('/admin')) {
    return getAdminBreadcrumbItems(pathname).map((item) => t(item.labelKey));
  }
  if (pathname.match(/^\/projects\/[^/]+\/notes$/)) {
    const items: string[] = [];
    if (projectTitle) {
      items.push(projectTitle);
    }
    items.push(t('Notes') || 'Notes');
    return items;
  }

  return [];
}
